import React from "react";
import { useNavigate } from "react-router-dom";

const KYC = ({ onCancel }) => {
  const navigate = useNavigate();
  const onClickHandler = () => {
    navigate("/kyc");
    onCancel();
  };

  return (
    <div
      className="flex text-xs font-medium py-1 pl-8"
      onClick={onClickHandler}
    >
      <img className="w-3 h-4 pt-1 mr-3 " src="/images/docs.png" alt="" />
      KYC Documents
    </div>
  );
};
export default KYC;
